module.exports = __webpack_public_path__ + "img/zx_blue.39af5dd1.png";